import { Component, OnInit, EventEmitter, Output, Input, TemplateRef, ViewChild, OnChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { PHBHPFeaturePackageConfigurationService } from "../ph-bhp-feature-package-configuration.service";
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { pdf } from '@progress/kendo-drawing';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-configure-turorial',
  templateUrl: './ph-bhp-configure-turorial.component.html',
  styleUrls: ['./ph-bhp-configure-turorial.component.css']
})
export class PhBhpConfigureTurorialComponent implements OnInit {

  @ViewChild('cancelmodal') cancelmodal: TemplateRef<any>;
  userData: any;
  submitted: boolean = false;
  addTutorialForm: UntypedFormGroup;
  searchText;
  modalRef: BsModalRef;
  public filePath;
  fileURL: any;
  type;
  public message: string;
  fileData: Array<any>;
  tutorialID: any;
  fileFormat: string;
  fileFormatName: string;
  selectedfilename
  filename
  tutorialFileDescriptionMaxlength = 1000;
  titleLength = 40;
  uploadMaxFileSize = 50; // in MB
  translationKeys: typeof TranslationKeys = TranslationKeys;
  public items: any[] = [];

  emitData: any = {
    key: "",
    val: ""
  }

  originalFileName: any;

  constructor(private service: PHBHPFeaturePackageConfigurationService, public layoutService: PHBHPLayoutPackageService, private modalService: BsModalService, public translate: TranslateService, private router: Router, private activatedRoute: ActivatedRoute, public config: AppConfig) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(paramsId => {
      this.tutorialID = paramsId.tutorialID;
    });
    this.addTutorialForm = new UntypedFormGroup({
      title: new UntypedFormControl("", Validators.compose([Validators.required])),
      description: new UntypedFormControl("", Validators.compose([Validators.required])),
      tags: new UntypedFormControl(""),
      type: new UntypedFormControl('', Validators.compose([Validators.required])),
      fileURL: new UntypedFormControl(""),
      fileName: new UntypedFormControl("", Validators.compose([Validators.required]))
    });

    if (this.tutorialID) {
      this.service.getTutorialsByTutorialId(this.tutorialID).subscribe((res: any) => {
        this.filename = res.fileURL.substring(res.fileURL.lastIndexOf('/') + 13);
        this.addTutorialForm.setValue({
          title: res.title,
          description: res.description,
          tags: JSON.parse(res.tags),
          type: res.type,
          fileName: this.filename,
          fileURL: null
        });
        this.originalFileName = this.filename;
        if (this.addTutorialForm.value.tags.length > 0) {
          for (let i = 0; i < this.addTutorialForm.value.tags.length; i++) {
            this.items.push(this.addTutorialForm.value.tags[i]);
          }
        }
      })
    }
  }

  onChildData(emitter) {
    this.router.navigate(['/configure/tutorial']);
  }

  onFormatChange(event) {
    this.fileFormat = event;
    switch (event) {
      case "pdf":
        this.fileFormatName = "pdf";
        break;
      case "video":
        this.fileFormatName = "video (.mp4,.webm)";
        break;
      default:
        this.fileFormatName = "";
    }
  }

  uploadfile(files) {
    if ((files[0].type.indexOf("pdf")) < 0 && (files[0].type.indexOf("mp4")) < 0 && (files[0].type.indexOf("webm")) < 0) {
      this.filename = this.originalFileName;
      this.layoutService.showError(this.layoutService.translateText('CONFIGURE.MESSAGE_INVALID_FILE.EXPECTED_PDF_MP4_OR_WEBM'));
      return;
    }
    if ((files[0].size / (1024 * 1024)) > this.uploadMaxFileSize) {
      this.filename = this.originalFileName;
      this.layoutService.showError(`${this.layoutService.translateText('CONFIGURE.FILE_SIZE_EXCEEDS')} ${this.uploadMaxFileSize} MB`);
      return;
    }

    this.filename = files[0].name;
    this.originalFileName = this.filename;

    this.addTutorialForm.patchValue({
      fileName: this.filename
    })

    // this.tutorialID = false;
    if (files.length === 0) return;
    var reader = new FileReader();
    this.filePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = _event => {
      this.fileURL = reader.result;
    };

    let fileType = ''
    if (files[0].type === 'application/pdf') {
      fileType = 'pdf'
    } else {
      fileType = 'video'
    }

    this.addTutorialForm.patchValue({ type: fileType });

    if (this.addTutorialForm.invalid) {
      return false;
    }
  }

  fileAccept() {
    if (this.fileFormat && this.fileFormat == "pdf") {
      return ".pdf";
    }
    else if (this.fileFormat && this.fileFormat == "video") {
      return "video/mp4,video/webm";
    }
    else {
      return ".pdf,video/mp4,video/webm";
    }
  }

  submitTutorial(files: any) {
    if (files[0] && (files[0].type.indexOf("pdf")) < 0 && (files[0].type.indexOf("mp4")) < 0 && (files[0].type.indexOf("webm")) < 0) {
      this.filename = this.originalFileName;
      this.layoutService.showError(this.layoutService.translateText('CONFIGURE.MESSAGE_INVALID_FILE.EXPECTED_PDF_MP4_OR_WEBM'));
      files = [];
    }

    if (!this.tutorialID) {
      this.saveTutorial(files);
    } else if (this.tutorialID) {
      this.updateTutorial(files);
    }

  }

  saveTutorial(files) {
    if (this.addTutorialForm.invalid) {
      return true;
    }
    if (files.length === 0)
      return;

    this.userData = this.config.userData;
    const value: any = this.addTutorialForm.value;
    var tutorialData = new FormData();
    tutorialData.append("title", value.title);
    tutorialData.append("tags", JSON.stringify(this.items));
    tutorialData.append('description', value.description);
    tutorialData.append('type', value.type);
    tutorialData.append('fileURL', files[0]);
    tutorialData.append('createdBy', this.userData.userId);
    tutorialData.append('language', localStorage.getItem('selectedlanguage'));
    this.selectedfilename = files[0].name.substring(files[0].name.lastIndexOf('.') + 1);
    if (this.selectedfilename != "pdf") {
      this.selectedfilename = "video"
    }
    if (value.type === this.selectedfilename) {
      this.layoutService.showLoader = true;
      this.service.createTutorial(tutorialData).subscribe((res: Array<any>) => {
        // this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.ADDED.TUTORIAL'));
        this.layoutService.showLoader = false;
        this.emitData = {};
        this.emitData.key = "";
        this.emitData.val = res;
        this.onChildData(this.emitData);
      });
    }
    else {
      this.layoutService.showError(this.layoutService.translateText('CONFIGURE.FILE_TYPE_MISMATCH'));
    }

  }

  updateTutorial(files) {

    if (this.addTutorialForm.invalid) {
      return true;
    }
    const value: any = this.addTutorialForm.value;

    var tutorialData = new FormData();
    tutorialData.append("title", value.title);
    tutorialData.append("tags", JSON.stringify(this.items));
    tutorialData.append('description', value.description);
    tutorialData.append('type', value.type);
    tutorialData.append('fileURL', files[0]);
    tutorialData.append('tutorialID', this.tutorialID);
    tutorialData.append('language', localStorage.getItem('selectedlanguage'));
    this.selectedfilename = value.fileName.substring(value.fileName.lastIndexOf('.') + 1);

    if (this.selectedfilename !== "pdf") {
      this.selectedfilename = "video"
    }

    if (value.type === this.selectedfilename) {
      this.layoutService.showLoader = true;
      this.service.updateTutorial(this.tutorialID, tutorialData).subscribe((res: Array<any>) => {
        // this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.TUTORIAL'));
        this.layoutService.showLoader = false;
        this.emitData = {};
        this.emitData.key = "";
        this.emitData.val = res;
        this.onChildData(this.emitData);
      });
    }
    else {
      this.layoutService.showError(this.layoutService.translateText('CONFIGURE.FILE_TYPE_MISMATCH'));
    }
  }

  cancelModal() {
    if (this.addTutorialForm.dirty) {
      this.openCancelModal(this.cancelmodal)
    }
    else {
      this.backToTutorials()
    }
  }

  openCancelModal(cancelmodal: TemplateRef<any>) {
    this.modalRef = this.modalService.show(cancelmodal, Object.assign({}, { class: 'w-420' })
    )
  }


  backToTutorials() {
    this.emitData = {};
    this.emitData.key = "/configure/tutorial";
    this.onChildData(this.emitData);
  }

  onInputTagKeyup(target: any): void {
    if (target.value == '' || target.value.length == 0) return;
    this.items.push({ value: target.value });
    target.value = '';
  }

  remove(tag: any): void {
    const index = this.items.indexOf(tag);
    if (index >= 0) {
      this.items.splice(index, 1);
    }
  }
}
